import { useCallback, useState } from 'react';
import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import { useTranslation } from 'react-i18next';
import {
    ButtonPropsModal,
    ItemsFooterType,
} from '@celebration/react/ClbModal/ClbModal.types';
import requestsTableService from '../../services/requests-table.service';
import { useToast } from '../../../../../../app/contexts/toast/toast.context';
import IReproveUserModal from './IReproveUserModal';

function ReproveUserModal({
    userToReprove,
    fetchData,
    reproveModalOpen,
    onReproveModalClose,
}: Readonly<IReproveUserModal>) {
    const { t } = useTranslation();

    const { setToast } = useToast();

    const [isLoading, setIsLoading] = useState(false);

    const handleReproveModalClose = useCallback(
        () => onReproveModalClose(),
        [onReproveModalClose],
    );

    const closeReproveModalHandler = useCallback(() => {
        if (!isLoading) {
            handleReproveModalClose();
        }
    }, [isLoading, handleReproveModalClose]);

    const cancelReproveButton: ButtonPropsModal = {
        key: 'cancel-reprove-button',
        id: 'cancel-reprove-button',
        label: t('Cancelar'),
        disabled: isLoading,
        loading: false,
        title: t('CancelarReprovacaoUsuario'),
        'data-testid': 'modal-back-button',
        onClick: () => handleReproveModalClose(),
        role: 'button',
        size: 'md',
        styleType: 'secondary',
    };

    const confirmReproveButton: ButtonPropsModal = {
        key: 'confirm-reprove-button',
        id: 'confirm-reprove-button',
        label: t('Confirmar'),
        disabled: false,
        loading: isLoading,
        title: t('ConfirmarReprovacaoUsuario'),
        'data-testid': 'modal-confirm-button',
        onClick: () => {
            setIsLoading(true);

            requestsTableService
                .reproveUserRequest(userToReprove)
                .then(() => {
                    setToast('positive', t('Sucesso'), t('UsuarioReprovado'));
                })
                .catch(err => {
                    setToast('negative', t('Erro'), err.message);
                })
                .finally(() => {
                    onReproveModalClose();
                    setIsLoading(false);
                    fetchData();
                });
        },
        role: 'button',
        size: 'md',
        styleType: 'danger',
    };

    const buttonsReproveModal: ItemsFooterType = [
        confirmReproveButton,
        cancelReproveButton,
    ];

    return (
        <ClbModal
            title={t('ConfirmarReprovacao')}
            open={reproveModalOpen}
            onClose={closeReproveModalHandler}
            description={t('CertezaReprovacaoUser')}
            type="danger"
            itemsFooter={buttonsReproveModal}
            data-testid="reprove-user-modal"
        />
    );
}

export default ReproveUserModal;
